import { Alert } from '@zillow/constellation-10';

import { PartialMessage } from '@zg-rentals/backend-styled-components';

import type { AlertPropsInterface } from '@zillow/constellation-10';
import type { PartialMessageProps } from '@zg-rentals/backend-styled-components';

type Props = {
  appearance?: AlertPropsInterface['tone'];
  errorMessages: Array<PartialMessageProps>;
};

const ErrorMessagesAlert = ({ appearance = 'critical', errorMessages = [] }: Props) => {
  return (
    <Alert tone={appearance}>
      <PartialMessage data-testid="PartialMessage" partialMessages={errorMessages} />
    </Alert>
  );
};

export default ErrorMessagesAlert;
